<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t('navigations.document review list') }}</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content">
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group mb-1">
        <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
          <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
            <label class="mb-0"> {{ $t("navigations.title") }}</label>
            <input
              v-model="searchField.documentTitle"
              type="text"
              class="form-control my-md-2 my-lg-0"
            />
          </div>
          <div class="form-group mb-lg-0 w-100 px-1">
            <label class="mb-0"> {{ $t("navigations.uploaded date") }}</label>
            <div class="input-group date">
              <input
                v-model="searchField.createdAt"
                type="date"
                class="form-control my-md-2 my-lg-0"
              />
            </div>
          </div>
          <div class="form-group mb-lg-0 w-100 px-1">
            <label class="mb-0"> {{ $t("navigations.review status") }}</label>
            <select
              class="form-select my-md-2 my-lg-0"
              v-model="searchField.status"
            >
              <option value="Completed">{{ $t("navigations.completed") }}</option>
               <option value="Pending">{{ $t("navigations.pending") }}</option>
              <option value="Closed">{{ $t("navigations.rejected") }}</option>
             
            </select>
          </div>
          <span
            @click="OnSearchButtonClicked"
            class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end"
          >
            {{ $t("navigations.search") }}
          </span>
        </div>
      </div>
    </div>

    <div class="ibox-body">
      <div class="ibox-title style_2">
        <h5 class="my-0">{{ $t("navigations.document review list") }}</h5>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
           <div class="text-center" v-if="showLoading === true">
          <img
            src="../../assets/img/loading.gif"
            width="15"
            class=""
            alt="Waiting for login"
          />
          <div>
            {{ $t("navigations.please wait while the list is being loaded") }}
          </div>
        </div>      
        <template  v-else>
          <div class="text-center" v-if="approvalList.length==0">
            {{ $t('navigations.no data available') }}
          </div>
          <table v-else class="table table-striped table-bordered dataTables">
            <thead>
              <tr>
                <th
                  @click="SortSelected('documentTitle',0)"
                  :class="{
                    sortAsc: SortProperty === 'documentTitle' && SortOrder,
                    sortDesc: SortProperty === 'documentTitle' && !SortOrder,
                  }"
                >
                  <div class="d-flex flex-row justify-content-between">
                    Document Title
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  @click="SortSelected('artifactName',1)"
                  :class="{
                    sortAsc: SortProperty === 'artifactName' && SortOrder,
                    sortDesc: SortProperty === 'artifactName' && !SortOrder,
                  }"
                >
                  <div class="d-flex flex-row justify-content-between">
                    Artifact Name
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th @click="SortSelected('createdUserName', 2)"
                 :class="{
                    sortAsc: SortProperty === 'createdUserName' && SortOrder,
                    sortDesc: SortProperty === 'createdUserName' && !SortOrder,
                  }">
                  <div class="d-flex flex-row justify-content-between">
                    Uploaded By
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="text-center" @click="SortSelected('CreatedAt', 3)"
                  :class="{
                    sortAsc: SortProperty === 'CreatedAt' && SortOrder,
                    sortDesc: SortProperty === 'CreatedAt' && !SortOrder,
                  }">
                  <div
                    class="d-flex flex-row justify-content-between text-center"
                  >
                    Uploaded Date
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th class="text-center" @click="SortSelected('version', 4)"
                  :class="{
                    sortAsc: SortProperty === 'version' && SortOrder,
                    sortDesc: SortProperty === 'version' && !SortOrder,
                  }">
                  <div
                    class="d-flex flex-row justify-content-between text-center"
                  >
                    Version
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th @click="SortSelected('approvedStatus', 5)"
                  :class="{
                    sortAsc: SortProperty === 'approvedStatus' && SortOrder,
                    sortDesc: SortProperty === 'approvedStatus' && !SortOrder,
                  }" >
                  <div class="text-center">
                    Review

                  </div>
                </th>
                <th
                  class="text-center"
                  @click="SortSelected('assignedByUsername', 6)"
                  :class="{
                    sortAsc: SortProperty === 'assignedByUsername' && SortOrder,
                    sortDesc: SortProperty === 'assignedByUsername' && !SortOrder,
                  }"
                >
                  <div class="d-flex flex-row justify-content-between">
                    Assigned By
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <th
                  class="text-center"
                  @click="SortSelected('assignedDateTime', 7)"
                  :class="{
                    sortAsc: SortProperty === 'assignedDateTime' && SortOrder,
                    sortDesc: SortProperty === 'assignedDateTime' && !SortOrder,
                  }"
                >
                  <div class="d-flex flex-row justify-content-between">
                    Assigned Date
                    <span>
                      <i class="fa fa-long-arrow-up"></i>
                      <i class="fa fa-long-arrow-down"></i>
                    </span>
                  </div>
                </th>
                <!-- <th class="text-center">Status</th> -->
                <th class="text-center">View</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="approval in approvalList" :key="approval.id">
                <td class="wrap-text">{{ approval.documentTitle }}</td>
                <td class="wrap-text">{{ approval.artifactName }}</td>
                <td>{{ approval.createdUserName }}</td>
                <td class="text-center">
                  {{
                    approval.createdAt ? approval.createdAt.slice(0, 10) : ""
                  }}
                </td>

                <td class="text-center">{{ approval.version }}</td>
                <td class="text-center">
                  <span
                    v-if="approval.approvedStatus == 'Pending'"
                    @click="ApproveReject(approval.id, approval.version)"
                  >
                    <a href="#"
                      ><img
                        src="../../assets/img/approval_status.png"
                        alt="approval_status"/></a
                  ></span>
                  <span v-if="approval.approvedStatus != 'Pending'">{{
                    approval.approvedStatus
                  }}</span>
                </td>
                <td>{{ approval.assignedByUsername }}</td>
                <td>
                  {{
                    approval.assignedDateTime
                      ? approval.assignedDateTime.slice(0, 10)
                      : ""
                  }}
                </td>
                <!-- <td class="text-center">
                  <span
                    class="cursor-pointer"
                    @click="
                      ApproveStatus(
                        approval.documentTitle,
                        approval.id,
                        approval.version
                      )
                    "
                  >
                    <span v-if="approval.approvedStatus == 'Approved'"
                      ><img
                        src="../../assets/img/approved.png"
                        alt="approval_status"
                    /></span>
                    <span v-if="approval.approvedStatus == 'Pending'"
                      ><img
                        src="../../assets/img/pending.png"
                        alt="approval_status"
                    /></span>
                    <span v-if="approval.approvedStatus == 'Rejected'"
                      ><img
                        src="../../assets/img/rejected.png"
                        alt="approval_status"/></span
                  ></span>
                </td> -->
                <td class="text-center">
                  <a
                    @click.prevent="
                      viewDocument(
                        approval.id,
                        approval.documentTitle,
                        approval.version
                      )
                    "
                  >
                    <i class="fa fa-eye edit-delete"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="col-md-12 d-flex justify-content-md-end px-0" v-if="approvalList.length!=0">
            <VPagination
              v-model="currentPage"
              :pages="totalPage"
              :range-size="1"
              active-color="#ededed"
              @update:modelValue="loadPage"
            />
          </div>
        </template>
        </div>
      </div>
    </div>
  </div>
  <!-- <customModal
    v-if="showpop == true"
    :containersm="true"
    :footerShow="true"
    @closeModal="close"
  >
    <template #title>
      {{ $t("navigations.approvals") }}
    </template>
    <template #body>
      <label class="col-form-label">Comments</label>
      <textarea
        class="form-control message-input"
        name="message"
        placeholder="Enter your comments here"
        v-model="comments"
      ></textarea>
    </template>
    <template #footer>
      <div class="text-center">
        <button
          type="button"
          class="btn btn-green-new text-white mr-2"
          @click="ApprovalStatus(true)"
        >
          {{ $t("navigations.approve") }}
        </button>
        <button
          type="button"
          class="btn btn-danger-new mr-2"
          @click="ApprovalStatus(false)"
        >
          {{ $t("navigations.reject") }}
        </button>
      </div>
    </template>
  </customModal> -->
  <QcReviewPopup
    v-if="showReviewPopup"
    context="review"
    :documentId="docId"
    :versionNo="versionNo"
    @close="showReviewPopup = false"
    @saved="onQcReviewSaved"
  />


 
  <customModal
    v-if="showstatuspop"
    :containersm="true"
    :footerShow="false"
    @closeModal="showstatuspop = false"
  >
    <template #title>
      {{ fileName }}
    </template>

    <template #body>
      <ul class="folder-list px-0 height-scroll">
        <li class="py-2" v-for="(data, index) in getbyId" :key="data.id">
          <div class="ibox mb-0">
            <a
              class="collapse-link d-flex justify-content-between"
              @click.prevent="showCollapseFunc(index)"
              :aria-expanded="showCollapse[index] ? true : false"
            >
              <span>{{ data.approvedByUsername }}</span>

              <span v-if="data.approvedStatus == 'Approved'" class="text-green">
                {{ data.approvedStatus }}
                <span class="small-text">
                  - {{ data.approvedDatetime.slice(0, 10) }}</span
                >
                <i
                  class="fa fa-chevron-down ml-2"
                  :class="showCollapse[index] ? 'rotate' : ''"
                ></i>
              </span>

              <span
                v-if="data.approvedStatus == 'Rejected'"
                class="text-danger"
              >
                {{ data.approvedStatus }}
                <span class="small-text">
                  - {{ data.approvedDatetime.slice(0, 10) }}</span
                >
                <i
                  class="fa fa-chevron-down ml-2"
                  :class="showCollapse[index] ? 'rotate' : ''"
                ></i>
              </span>

              <span
                v-if="data.approvedStatus == 'Pending'"
                class="text-warning"
              >
                {{ data.approvedStatus }}
                <i
                  class="fa fa-chevron-down ml-2"
                  :class="showCollapse[index] ? 'rotate' : ''"
                ></i>
              </span>
            </a>

            <div class="ibox-content" v-if="showCollapse[index]">
              <p class="text-break">
                {{ data.comments }}
              </p>
            </div>
          </div>
        </li>
      </ul>
    </template>
  </customModal>
</template>

<script src="./TmfDocReviewList.js"></script>
<style scoped>
.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}
.badge-warning {
  background-color: #f8ac59;
  color: #ffffff;
}
.badge-danger {
  background-color: #ed5565;
  color: #ffffff;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 200px;
}
.btn-green-new {
  color: #fff;
  background-color: #1ab394;
  /* border-color: #1ab394; */
  border: none;
}
.btn-danger-new {
  color: #fff;
  background-color: #ed5565;
  border: none;
}
.text-green {
  color: #1ab394 !important;
}
.rotate {
  transform: rotate(180deg);
  transition: all 0.3s ease;
}
.height-scroll {
  height: 250px;
  overflow-y: auto;
}
.small-text {
  font-size: 80%;
  font-weight: 400;
  color: #6b6b6b;
}
</style>
